import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import StatusPill from '../../components/StatusPill';

export default function CopyRelationships() {
  const [data, setData]     = useState({ relationships: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage]     = useState(1);

  useEffect(() => {
    api.get('/admin/copy-relationships', { params: { page, limit: 30 } })
      .then(r => setData(r.data))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <>
      <div className="ct-page-header">
        <div>
          <h1>Copy Relationships</h1>
          <div className="subtitle">Every active link between traders and copiers</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h5 className="card-title">Relationships</h5>
          <div className="card-category" style={{marginTop:4}}>{data.total} total</div>
        </div>
        <div className="card-body" style={{padding:0}}>
          {loading ? (
            <div style={{padding:20, color:'var(--text-secondary)'}}>Loading…</div>
          ) : data.relationships.length === 0 ? (
            <div style={{padding:32, color:'var(--text-secondary)', textAlign:'center'}}>
              No copy relationships yet.
            </div>
          ) : (
            <div className="table-responsive table-cards table-cards-wrap">
              <table className="table">
                <thead>
                  <tr>
                    <th>Trader</th>
                    <th>Copier</th>
                    <th>Mode</th>
                    <th className="num">Risk</th>
                    <th>Status</th>
                    <th className="num">Copied</th>
                    <th className="num">Total P&amp;L</th>
                    <th>Last Activity</th>
                  </tr>
                </thead>
                <tbody>
                  {data.relationships.map(r => {
                    const pnl = r.totalPnl ?? 0;
                    return (
                      <tr key={r._id}>
                        {/* A follow edge is account-to-account, so name both
                            ends: "brian → shin" is ambiguous once either side
                            has more than one MT5 account. */}
                        <td data-label="Trader" className="small">
                          <div>{r.traderId?.username || r.traderId?.email || '—'}</div>
                          <div style={{color:'var(--text-tertiary)'}}>{r.traderAccountLabel || '—'}</div>
                        </td>
                        <td data-label="Copier" className="small">
                          <div>{r.copierId?.username || r.copierId?.email || '—'}</div>
                          <div style={{color:'var(--text-tertiary)'}}>{r.copierAccountLabel || '—'}</div>
                        </td>
                        <td data-label="Mode"><span className="badge badge-info">{r.scalingMode}</span></td>
                        <td data-label="Risk" className="num">{r.riskMultiplier}×</td>
                        <td data-label="Status"><StatusPill status={r.status} /></td>
                        <td data-label="Copied" className="num">{r.totalCopiedTrades}</td>
                        <td data-label="Total P&L" className="num" style={{color: pnl >= 0 ? 'var(--profit)' : 'var(--loss)', fontWeight:500}}>
                          {pnl >= 0 ? '+' : ''}{Number(pnl).toFixed(2)}
                        </td>
                        <td data-label="Last Activity" className="small" style={{color:'var(--text-tertiary)'}}>
                          {r.lastActivity ? new Date(r.lastActivity).toLocaleString() : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{
                display:'flex',justifyContent:'space-between',alignItems:'center',
                padding:'14px 20px',borderTop:'1px solid var(--border-subtle)'
              }}>
                <span style={{color:'var(--text-tertiary)',fontSize:12}}>
                  Page {page} — {data.relationships.length} / {data.total}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-sm btn-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</button>
                  <button className="btn btn-sm btn-secondary" disabled={data.relationships.length < 30} onClick={() => setPage(p => p + 1)}>Next</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
